// this function returns the fields that are translatable, and
// of which the default value is not empty, but does not have a translated value
// e.g.: nickname is filled, but nickname is missing in the german translation
export const emptyTranslatableFields = function(
  defaultModel,
  TranslationInfo,
  translatableProperties,
) {
  const result = {}
  const availableLanguages = TranslationInfo.AvailableCultures.map(culture => culture.Name)

  function defaultValueIsSet(property) {
    if (property === 'Usps' && Array.isArray(defaultModel[property])) {
      return !!defaultModel[property].join('')
    }
    return !!defaultModel[property]
  }

  function handleEmptyThemeProperty(languageCode, property) {
    for (const themeValue of Object.values(TranslationInfo.Translations[languageCode][property])) {
      if (themeValue.name === null || themeValue.name === '') return true
    }
    return false
  }

  function handleEmptyFiltersProperty(languageCode, property) {
    for (const filterValue of Object.values(TranslationInfo.Translations[languageCode][property])) {
      if (filterValue.name === null || filterValue.name === '') return true
      for (const filterRowValue of Object.values(filterValue.rows)) {
        if (filterRowValue.name === null || filterRowValue.name === '') return true
      }
    }
    return false
  }

  function handleEmptyProgramProperty(languageCode, property) {
    if (TranslationInfo.Translations[languageCode][property] === null) return false
    for (const programValue of Object.values(
      TranslationInfo.Translations[languageCode][property],
    )) {
      if (programValue[0].title === null || programValue[0].title === '') return true
    }
    return false
  }

  function handleEmptyUspsProperty(languageCode, property) {
    if (Array.isArray(TranslationInfo.Translations[languageCode][property]))
      return !TranslationInfo.Translations[languageCode][property].join('')
    else return !TranslationInfo.Translations[languageCode][property]
  }

  function translatedValueIsEmpty(languageCode, property) {
    switch (property) {
      case 'Usps':
        return handleEmptyUspsProperty(languageCode, property)
      case 'Theme':
        return handleEmptyThemeProperty(languageCode, property)
      case 'Filters':
        return handleEmptyFiltersProperty(languageCode, property)
      case 'Program':
        return handleEmptyProgramProperty(languageCode, property)
      default:
        return !TranslationInfo.Translations[languageCode][property]
    }
  }

  translatableProperties.forEach(property => {
    if (defaultValueIsSet(property.key)) {
      Object.keys(TranslationInfo.Translations).forEach(languageCode => {
        if (
          availableLanguages.includes(languageCode) &&
          translatedValueIsEmpty(languageCode, property.key)
        ) {
          if (!result[languageCode]) {
            result[languageCode] = []
          }
          result[languageCode].push(property.label)
        }
      })
    }
  })
  return result
}

export const emptyTranslatableFieldsExist = function(
  defaultModel,
  TranslationInfo,
  translatableProperties,
) {
  const fields = emptyTranslatableFields(defaultModel, TranslationInfo, translatableProperties)
  const fieldsExist = Object.keys(fields).length > 0
  return fieldsExist
}
